// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fdew","newExpiryDate":"styles_newExpiryDate__jGmms","footer":"styles_footer__Qr4FB"};